import { useEffect, useState } from "react";

// Smoothly counts to a target number over `duration` ms. Respects reduced motion.
export default function AnimatedNumber({ value, duration = 500, format = (n) => n.toString() }) {
    const [display, setDisplay] = useState(value);
    useEffect(() => {
        const prefersReduced = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
        if (prefersReduced || !Number.isFinite(value) || !Number.isFinite(display)) {
            setDisplay(value);
            return;
        }
        const start = display;
        const delta = value - start;
        if (delta === 0) return;
        const t0 = performance.now();
        let raf;
        const tick = (now) => {
            const p = Math.min(1, (now - t0) / duration);
            const eased = 1 - Math.pow(1 - p, 3);
            setDisplay(start + delta * eased);
            if (p < 1) raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, duration]);
    return <>{format(display)}</>;
}
